import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

import { BaseHttpService } from '../../fwcore/services';
import urlJoin from 'url-join';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import * as ProjectSetupModel from '../models/project-setup';
export declare const EMPTY: Observable<never>;
@Injectable({
  providedIn: 'root'
})
export class ApiService extends BaseHttpService {

  //To hold SC service 
  public scBaseUrl!: string;
  public ngsSCBaseUrl!: string;

  //CPQ APIs
  public ngsCPQBaseUrl!: string;

  // NGS Projects Base URL
  public ngsProjectsBaseUrl!: string;

  //To hold SC API key
  public scAPIKey !: string;

  //To hold generic API key
  public genAPIKey !: string;

  //Holders for Master Data APIs
  public $scMasterDataAPI : any;
  public $providerRegoinMasterAPI: any;
  public $providerIndustryMasterAPI: any;
  public $engagementQuestionsAPI: any;
  public $jobTitlesAPI: any;
  public $pronounsAPI: any;
  public $expertiseAPI: any;
  public $providerMasterListAPI: any;
  public $providerAddReasonAPI: any;
  public $providerRemoveReasonAPI: any;
  public $providerReinstateReasonAPI: any;
  
  public $conactMasterRoleAPI: any;
  //Holders for Master Data APIs

  //To manage cached APIs
  public _cachedAPIs$ = new BehaviorSubject<void>(undefined); 


  //To show success message on project details page
  public isProjectSetupComplete = new BehaviorSubject<boolean>(false);
  adminUrl: any;
  hostName: any;

  public projectBaseUrl: string;
  public providerSummaryUrl: string;
  public workspaceDetails?: WorkSpace;
  defaultList = new BehaviorSubject<FAQQuestionList[]>([]);
  constructor(
    private _http: HttpClient
    , @Inject(OKTA_AUTH) private _auth: OktaAuth
    , @Inject('CONFIG_SETTINGS') private _config: any
  ) {
    super(_http);
    this.baseUrl = _config['oneSys']['endPoint'];
    this.genAPIKey = _config['general']['apiKey'];
    this.adminUrl = _config['general']['adminApiUrl'];
    this.hostName = _config['general']['hostName'];

    this.ngsProjectsBaseUrl = _config['general']['adminApiUrl'] + _config['general']['ngsProjects'];
    this.ngsCPQBaseUrl = _config['general']['adminApiUrl'] + 'cpq';
    this.ngsSCBaseUrl = _config['general']['adminApiUrl'] + 'servicecatalogue';
    this.scBaseUrl = _config['serviceCatalogue']["url"];
    this.scAPIKey = _config['serviceCatalogue']["key"];
    this.projectBaseUrl = _config['general']['adminApiUrl'] + 'project';
    this.providerSummaryUrl = _config['general']['adminApiUrl'] + 'summarizedproviderresponses';
  }

  //Get Auth token
  public getToken(apiKey?: string): string | undefined {
    this.apiKey = apiKey || this.genAPIKey;
    return this._auth.getAccessToken();
  }
  
  //getWorkspaceName(): Observable<any> {
  //  //const token = this.getToken() ?? '';
  //  let parameter = "?hostName=" + this.hostName;
  //  const url = urlJoin(this.adminUrl, `api/Userlogin/GetWorkspaceName${parameter}`);
  //  //return this.getItems(url, this.getHttpBearerHeaders(token));
  //  return this.getItems(url, this.getHttpBearerHeaders(""));
  //}

  //GetFAQQuestionList(): Observable<any> {
  //  //const token = this.getToken() ?? '';
  //  const url = urlJoin(this.adminUrl, `api/Userlogin/GetFAQQuestionList`);
  //  return this.getItems(url, this.getHttpBearerHeaders(""));
  //  //return this.getItems(url, this.getHttpBearerHeaders(token));
  //}


  //FetchWorkspaceDetails(): Observable<any> {
  //  //const token = this.getToken() ?? '';
  //  let parameter = "?hostName=" + this.hostName;
  //  const url = urlJoin(this.adminUrl, `api/Userlogin/FetchWorkspaceDetails${parameter}`);  
  //  //return this.getItems(url, this.getHttpBearerHeaders(token));
  //  return this.getItems(url, this.getHttpBearerHeaders(""));
  //}
  getWorkspaceName(): Observable<any> {
    let parameter = "?hostName=" + this.hostName;
    const url = urlJoin(this.adminUrl, `api/Userlogin/GetWorkspaceName${parameter}`);
    return this.getItems(url, undefined); // No token
  }

  GetFAQQuestionList(): Observable<any> {
    const url = urlJoin(this.adminUrl, `api/Userlogin/GetFAQQuestionList`);
    return this.getItems(url, undefined); // No token
  }

  FetchWorkspaceDetails(): Observable<any> {
    let parameter = "?hostName=" + this.hostName;
    const url = urlJoin(this.adminUrl, `api/Userlogin/FetchWorkspaceDetails${parameter}`);
    return this.getItems(url, undefined); // No token
  }

  IsValidUserDetails(tmpUserName: string): Observable<any> {
    const payload = {
      userEmail: tmpUserName,
      domainName: this.hostName,
    };

    let token = this.getToken();
    if (token != null) {
      const url = urlJoin(this.adminUrl, 'api/Userlogin/IsValidUser');
      const httpHeaders = this.getHttpBearerHeaders(token);
      const content = payload;
      return this.postAny(content, url, httpHeaders);

    } else {
      // If there is no token, return an observable that emits an error
      return throwError(new Error("Token is null. User validation cannot proceed."));
    }
    
  }
    
}
interface FAQQuestionList {
  questionText: string;
  answer: string;
  imageBlob: string;
}
interface WorkSpace {
  workSpaceId: number;
  workSpaceName: string;
  workSpaceLogo: string;
  hostName: string;
  loginPageLogo: string;
  supportEmail: string;
}
